const seriesLabel = {
  normal: {
    formatter: "{b}",
    show: true,
    position: "right",
    textStyle: {
      color: "white",
      fontFamily: "normal",
    },
  },
};
export default {
  title: {
    text: "长三角各地区供应商数目 Top3",
  },

  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
    formatter: function (params) {
      let text = "";
      for (let i = 0; i < params.length; i++) {
        text = text + params[i].name + " : " + params[i].value + "<br>";
      }
      return text;
    },
  },

  grid: {},
  toolbox: {
    show: false,
    feature: {
      saveAsImage: {},
    },
  },
  xAxis: {
    type: "value",
    name: "数量",
    axisLabel: {
      formatter: "{value}",
    },
    max: 1500,
  },
  yAxis: {
    type: "category",
    inverse: true,
    data: ["江苏", "浙江", "上海", "安徽"],
  },
  series: [
    {
      name: "Top1",
      type: "bar",
      data: [
        { name: "苏州", value: 1177 },
        { name: "杭州", value: 839 },
        { name: "浦东", value: 709 },

        { name: "合肥", value: 194 },
      ],
      label: seriesLabel,
    },
    {
      name: "Top2",
      type: "bar",
      label: seriesLabel,
      data: [
        { name: "南京", value: 971 },
        { name: "宁波", value: 395 },
        { name: "金山区", value: 411 },

        { name: "安庆", value: 56 },
      ],
    },
    {
      name: "Top3",
      type: "bar",
      label: seriesLabel,
      data: [
        { name: "常州", value: 793 },
        { name: "台州", value: 210 },
        { name: "嘉定区", value: 364 },

        { name: "滁州", value: 50 },
      ],
    },
  ],
};
